import React, { useContext } from "react";
import { css } from "emotion";
import { boxStyles } from "../../styles/theme";
import TitleWithBackButton from "../TitleWithBackButton";
import WorkspaceListItem from "../Settings/WorkspaceListItem";
import { GlobalContext } from "../../context/GlobalState";

const SwitchWorkspaceBody = () => {
  const { workspaces } = useContext(GlobalContext);
  return (
    <div className={container}>
      <div className="desktop">
        <TitleWithBackButton title="Switch Workspace" backLocation="settings" />
      </div>

      <div className="main-card">
        {workspaces.map((workspace, index) => (
          <WorkspaceListItem
            workspace={workspace}
            index={index}
            arrayLength={workspaces.length}
            key={workspace.id}
          />
        ))}
      </div>
    </div>
  );
};

export default SwitchWorkspaceBody;

const container = css`
  width: 100%;
  padding-top: 30px;
  margin: auto;

  .desktop {
    display: none;
  }

  .main-card {
    flex-direction: column;
    width: 100%;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    width: 80%;
    .desktop {
      display: block;
    }
    .main-card {
      box-shadow: ${boxStyles.boxShadow};
      border-radius: ${boxStyles.borderRadius};
    }
  }
`;
